import { render } from "./Pwa.vue?vue&type=template&id=d2f74c4c"
import script from "./Pwa.vue?vue&type=script&lang=js"
export * from "./Pwa.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__